module.exports = __webpack_public_path__ + "img/focus.0127bfb2.png";